import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Box, Button, FormControl, FormLabel, Grid, Radio, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ChipSelect from "../FilterModal/ChipSelect";
import ArticleIcon from "@mui/icons-material/Article";
import Modal from "../Modal";
import { ReactComponent as PDFIcon } from "../../../assets/icons/Clients_Flow_Icons/modalIcon/PDFIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../assets/icons/Clients_Flow_Icons/modalIcon/ExcelIcon.svg";
import apiClient from "lib/api-client";
import { toast } from "react-toastify";

const WhatsAppModalBody = ({ mobileNumber, setMobileNumber, sendTo, setSendTo, reportOptions, onClick, type, data }) => (
  <>
    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#000000", fontSize: "22px", fontWeight: "Poppins", marginBottom: "32px", lineHeight: "22px", letterSpacing: "-0.41px" }}>
      Whatsapp Pdf - {data?.header?.split(" items")[0].replaceAll("/", " | ")}
    </Typography>
    <Box
      sx={{
        // width: "f",
        // height: 298,
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      {/* Mobile Number */}
      <Grid item lg={12} width={"100%"}>
        <FormControl fullWidth>
          <FormLabel sx={{ marginBottom: "20px !important", fontSize: "20px", fontWeight: 400, lineHeight: "22px", letterSpacing: "-0.41px", fontFamily: "Poppins" }}>Mobile Number</FormLabel>
          <div
            style={{
              border: "1px solid black",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="mobileRef"
          >
            <p
              style={{
                position: "absolute",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#989898",
                lineHeight: "100%",
                visibility: mobileNumber.length > 2 ? "hidden" : "",
              }}
            >
              Mobile Number
            </p>
            <PhoneInput
              country={"in"}
              value={mobileNumber}
              onChange={(value) => {
                setMobileNumber(value);
              }}
              placeholder="Phone Number"
              countryCodeEditable={false}
              disableDropdown={true}
              autoFormat={true}
              inputProps={{
                name: "mobileNumber",
                required: true,
                autoFocus: true,
                autoComplete: "off",
              }}
              //   inputStyle={{
              //     backgroundColor: !isPhoneValid ? "transparent" : "transparent",
              //   }}
              //   dropdownStyle={{
              //     height: !isEditClinet ? "150px" : "120px",
              //     fontSize: "20px",
              //     paddingTop: "10px",
              //     width: "360px",
              //     marginTop: "15px",
              //     borderRadius: "5px",
              //   }}
              //   isValid={(inputNumber, country) => {
              //     const isValid = handleValidation(inputNumber, country);
              //     setIsPhoneValid(isValid);
              //     return isValid;
              //   }}
            />
          </div>
        </FormControl>
      </Grid>

      {/* Select Report */}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 400, fontSize: "20px", color: "#000000", marginBottom: "20px !important", fontFamily: "Poppins", lineHeight: "22px", letterSpacing: "-0.41px" }}>
          Select Report {type === "dues" || type === "ledger" ? `(Transactions)` : `(Quotes & Orders)`}
        </Typography>
        <ChipSelect
          value={sendTo?.reportName}
          onChange={(e) => {
            const selected = reportOptions.find((x) => x.reportName === e.target.value);
            setSendTo(selected);
          }}
          options={reportOptions.map((r) => r.reportName)}
          placeholder="Select Client"
          menuStyles={{ maxHeight: "200px", overflowY: "auto" }}
          width="400px"
          multiple={false}
        />
      </Box>

      {/* Share Button */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={onClick}
          sx={{
            height: "44px",
            width: "200px",
            borderRadius: "6px",
            backgroundColor: mobileNumber?.replace(/\D/g, "").length === 12 && sendTo ? "#50C878" : "#444444",
            fontWeight: 400,
            "&:hover": {
              backgroundColor: mobileNumber?.replace(/\D/g, "").length === 12 && sendTo ? "#50C878" : "#444444",
            },
            fontFamily: "Karla",
            fontSize: "18px",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            textTransform: "capitalize !important",
          }}
        >
          Share
        </Button>
      </div>
    </Box>
  </>
);

const EmailModalBody = ({ selectedFormat, setSelectedFormat, handleFormatChange, sendTo, setSendTo, reportOptions, email, setEmail, onClick, type, data }) => (
  <>
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 500,
        color: "#000000",
        fontSize: "22px",
        fontFamily: "Poppins",
        marginBottom: "32px",
        lineHeight: "22px",
        letterSpacing: "-0.41px",
      }}
    >
      Email Pdf - {data?.header?.split(" items")[0].replaceAll("/", " | ")}
    </Typography>

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      <Grid item lg={12} width={"100%"}>
        <FormControl fullWidth>
          <FormLabel
            sx={{
              marginBottom: "20px !important",
              fontSize: "20px",
              color: "#000",
              fontWeight: 400,
              lineHeight: "22px",
              letterSpacing: "-0.41px",
              fontFamily: "Poppins",
            }}
          >
            Email
          </FormLabel>
          <TextField
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            fullWidth
            placeholder="Email address"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px",
                color: "#000000",
                "& fieldset": {
                  borderColor: "#000",
                },
                "&:hover fieldset": {
                  borderColor: "#000",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontFamily: "Poppins",
                padding: "12px 14px",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#989898",
                opacity: 1,
              },
            }}
          />
        </FormControl>
      </Grid>

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            color: "#000000",
            marginBottom: "20px !important",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            fontFamily: "Poppins",
          }}
        >
          Select Report {type === "dues" || type === "ledger" ? `(Transactions)` : `(Quotes & Orders)`}
        </Typography>
        <ChipSelect
          value={sendTo?.reportName}
          onChange={(e) => {
            const selected = reportOptions.find((x) => x.reportName === e.target.value);
            setSendTo(selected);
          }}
          options={reportOptions?.map((r) => r.reportName)}
          placeholder="Select Client"
          menuStyles={{ maxHeight: "200px", overflowY: "auto" }}
          width="100%"
          multiple={false}
        />
      </Box>

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            color: "#000000",
            marginBottom: "20px !important",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            fontFamily: "Poppins",
          }}
        >
          Select Format
        </Typography>

        <Box sx={{ display: "flex", gap: "16px" }}>
          <Box
            onClick={() => setSelectedFormat("pdf")}
            sx={{
              flex: 1,
              padding: "20px",
              // border: selectedFormat === "pdf" ? "2px solid #4CAF50" : "1px solid #E0E0E0",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: selectedFormat === "pdf" ? "#F2F2F0" : "#F2F2F0",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: selectedFormat === "pdf" ? "#F2F2F0" : "#F2F2F0",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                }}
              >
                <PDFIcon />
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000" }}>PDF</Typography>
            </Box>
            <Radio
              checked={selectedFormat === "pdf"}
              onChange={handleFormatChange}
              value="pdf"
              sx={{
                color: "#000",
                "&.Mui-checked": {
                  color: "#50C878",
                },
              }}
            />
          </Box>

          {/* Excel Option */}
          <Box
            onClick={() => setSelectedFormat("excel")}
            sx={{
              flex: 1,
              padding: "20px",
              // border: selectedFormat === "excel" ? "2px solid #4CAF50" : "1px solid #E0E0E0",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: selectedFormat === "excel" ? "#F2F2F0" : "#F2F2F0",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: selectedFormat === "excel" ? "#F2F2F0" : "#F2F2F0",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                }}
              >
                <ExcelIcon />
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000" }}>Excel</Typography>
            </Box>
            <Radio
              checked={selectedFormat === "excel"}
              onChange={handleFormatChange}
              value="excel"
              sx={{
                color: "#000",
                "&.Mui-checked": {
                  color: "#50C878",
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Share Button */}
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
        <Button
          variant="contained"
          onClick={onClick}
          sx={{
            height: "50px",
            width: "240px",
            borderRadius: "8px",
            backgroundColor: selectedFormat && sendTo && email ? "#50C878" : "#444",
            fontWeight: 400,
            fontSize: "18px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: selectedFormat && sendTo && email ? "#50C878" : "#444",
            },
            fontFamily: "Karla",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
          }}
        >
          Share
        </Button>
      </Box>
    </Box>
  </>
);

const DownloadModalBody = ({ selectedFormat, setSelectedFormat, handleFormatChange, sendTo, setSendTo, reportOptions, onClick, type, data, isLoading }) => (
  <>
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 500,
        color: "#000000",
        fontSize: "22px",
        fontFamily: "Poppins",
        marginBottom: "32px",
        lineHeight: "22px",
        letterSpacing: "-0.41px",
      }}
    >
      Download - {data?.header?.split(" items")[0].replaceAll("/", " | ")}
    </Typography>

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            color: "#000000",
            marginBottom: "20px !important",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            fontFamily: "Poppins",
          }}
        >
          Select Report {type === "dues" || type === "ledger" ? `(Transactions)` : `(Quotes & Orders)`}
        </Typography>
        <ChipSelect
          value={sendTo?.reportName}
          onChange={(e) => {
            const selected = reportOptions.find((x) => x.reportName === e.target.value);
            setSendTo(selected);
          }}
          options={reportOptions.map((r) => r.reportName)}
          placeholder="Select Client"
          menuStyles={{ maxHeight: "200px", overflowY: "auto" }}
          width="100%"
          multiple={false}
        />
      </Box>

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            color: "#000000",
            marginBottom: "20px !important",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            fontFamily: "Poppins",
          }}
        >
          Select Format
        </Typography>

        <Box sx={{ display: "flex", gap: "16px" }}>
          <Box
            onClick={() => setSelectedFormat("pdf")}
            sx={{
              flex: 1,
              padding: "20px",
              // border: selectedFormat === "pdf" ? "2px solid #4CAF50" : "1px solid #E0E0E0",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: selectedFormat === "pdf" ? "#F2F2F0" : "#F2F2F0",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: selectedFormat === "pdf" ? "#F2F2F0" : "#F2F2F0",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                }}
              >
                <PDFIcon />
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000" }}>PDF</Typography>
            </Box>
            <Radio
              checked={selectedFormat === "pdf"}
              onChange={handleFormatChange}
              value="pdf"
              sx={{
                color: "#000",
                "&.Mui-checked": {
                  color: "#50C878",
                },
              }}
            />
          </Box>

          <Box
            onClick={() => setSelectedFormat("excel")}
            sx={{
              flex: 1,
              padding: "20px",
              // border: selectedFormat === "excel" ? "2px solid #4CAF50" : "1px solid #E0E0E0",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: selectedFormat === "excel" ? "#F2F2F0" : "#F2F2F0",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: selectedFormat === "excel" ? "#F2F2F0" : "#F2F2F0",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                }}
              >
                <ExcelIcon />
              </Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000" }}>Excel</Typography>
            </Box>
            <Radio
              checked={selectedFormat === "excel"}
              onChange={handleFormatChange}
              value="excel"
              sx={{
                color: "#000",
                "&.Mui-checked": {
                  color: "#50C878",
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
        <Button
          variant="contained"
          onClick={onClick}
          disabled={!selectedFormat || !sendTo || isLoading}
          sx={{
            height: "50px",
            width: "240px",
            borderRadius: "8px",
            backgroundColor: !selectedFormat || !sendTo || isLoading ? "#777" : "#50C878",
            fontWeight: 400,
            textTransform: "none",
            "&:hover": {
              backgroundColor: !selectedFormat || !sendTo || isLoading ? "#777" : "#50C878",
            },

            "&.Mui-disabled": {
              backgroundColor: "#777 !important",
              color: "#000 !important",
              opacity: 1,
              cursor: "not-allowed",
            },
            fontFamily: "Karla",
            fontSize: "18px",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
          }}
        >
          {isLoading ? "Downloading..." : "Download"}
        </Button>
      </Box>
    </Box>
  </>
);

// BA Models...

const WhatsAppBAModalBody = ({ mobileNumber, setMobileNumber, onClick, type }) => (
  <>
    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#000000", fontSize: "24px", fontWeight: "Poppins", marginBottom: "32px", lineHeight: "22px", letterSpacing: "-0.41px" }}>
      Share {type} (BA report)
    </Typography>

    <Box
      sx={{
        width: "350px",
        // height: 298,
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      {/* Mobile Number */}
      <Grid item lg={12} width={"100%"}>
        <FormControl fullWidth>
          <FormLabel sx={{ marginBottom: "20px !important", fontSize: "20px", fontWeight: 400, lineHeight: "22px", letterSpacing: "-0.41px", fontFamily: "Poppins" }}>Mobile Number</FormLabel>
          <div
            style={{
              border: "1px solid black",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="mobileRef"
          >
            <p
              style={{
                position: "absolute",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#989898",
                lineHeight: "100%",
                visibility: mobileNumber.length > 2 ? "hidden" : "",
              }}
            >
              Mobile Number
            </p>
            <PhoneInput
              country={"in"}
              value={mobileNumber}
              onChange={(value) => {
                setMobileNumber(value);
              }}
              placeholder="Phone Number"
              countryCodeEditable={false}
              disableDropdown={true}
              autoFormat={true}
              inputProps={{
                name: "mobileNumber",
                required: true,
                autoFocus: true,
                autoComplete: "off",
              }}
            />
          </div>
        </FormControl>
      </Grid>

      {/* Share Button */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={onClick}
          sx={{
            height: "44px",
            width: "200px",
            borderRadius: "6px",
            backgroundColor: mobileNumber?.replace(/\D/g, "").length === 12 ? "#50C878" : "#444444",
            fontWeight: 400,
            "&:hover": {
              backgroundColor: mobileNumber?.replace(/\D/g, "").length === 12 ? "#50C878" : "#444444",
            },
            fontFamily: "Karla",
            fontSize: "18px",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
            textTransform: "capitalize !important",
          }}
        >
          Share
        </Button>
      </div>
    </Box>
  </>
);

const EmailModalBABody = ({ email, setEmail, onClick, type }) => (
  <>
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 500,
        color: "#000000",
        fontSize: "22px",
        fontFamily: "Poppins",
        marginBottom: "32px",
        lineHeight: "22px",
        letterSpacing: "-0.41px",
      }}
    >
      Email {type} (BA report)
    </Typography>

    <Box
      sx={{
        width: "350px",
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
    >
      <Grid item lg={12} width={"100%"}>
        <FormControl fullWidth>
          <FormLabel
            sx={{
              marginBottom: "20px !important",
              fontSize: "20px",
              color: "#000",
              fontWeight: 400,
              lineHeight: "22px",
              letterSpacing: "-0.41px",
              fontFamily: "Poppins",
            }}
          >
            Email
          </FormLabel>
          <TextField
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            fullWidth
            placeholder="Email address"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px",
                color: "#000000",
                "& fieldset": {
                  borderColor: "#000",
                },
                "&:hover fieldset": {
                  borderColor: "#000",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontFamily: "Poppins",
                padding: "12px 14px",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#989898",
                opacity: 1,
              },
            }}
          />
        </FormControl>
      </Grid>

      {/* Share Button */}
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
        <Button
          variant="contained"
          onClick={onClick}
          sx={{
            height: "50px",
            width: "240px",
            borderRadius: "8px",
            backgroundColor: email ? "#50C878" : "#444",
            fontWeight: 400,
            fontSize: "18px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: email ? "#50C878" : "#444",
            },
            fontFamily: "Karla",
            lineHeight: "22px",
            letterSpacing: "-0.41px",
          }}
        >
          Share
        </Button>
      </Box>
    </Box>
  </>
);

const ClientDynamicModal = ({ open, handleClose, modalType, onClick, type, data, JewelTransId }) => {
  let modal;

  // const reportOptions = ["Binny’s Jewelry Invoice", "Sunit", "tanish", "anubhav", "Sumit"];

  const [reportOptions, setReportOptions] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [sendTo, setSendTo] = useState("");
  const [email, setEmail] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);

  const fetchReportList = async () => {
    try {
      const reportType = type === "dues" || type === "ledger" ? "Transaction" : "Order";

      const companyId = sessionStorage.getItem("companyId");

      let url = `/api/v9/myBinnys/reportListForVision/?type=${reportType}`;

      if (companyId) {
        url += `&companyId=${companyId}`;
      }

      const res = await apiClient(url);
      // const names = res?.data?.data?.map((item) => item.reportName) || [];
      // setReportOptions(names);

      const options = res?.data?.data || [];
      setReportOptions(options);

      if (options.length > 0) {
        setSendTo(options[0]);
      }

      // setSendTo(names[0] || "");
    } catch (error) {
      console.log("Error fetching report list:", error);
    }
  };

  const handleDownload = async () => {
    if (!selectedFormat || !sendTo) return;

    setIsDownloading(true);

    // console.log("selectedFormat====>>>>",selectedFormat);

    const reportFormat = selectedFormat === "pdf" ? 1 : 2;
    const reportId = sendTo.reportId;
    const reportType = type === "dues" ? "due" : "ledger";

    // console.log("JewelTransId===>>>",JewelTransId)

    try {
      const res = await apiClient(`/api/v9/myBinnys/${reportType}/download/${JewelTransId}?reportFormat=${reportFormat}&reportId=${reportId}`);

      const fileUrl = res?.data?.data;

      if (!fileUrl) {
        console.log("File URL missing");
        setIsDownloading(false);
        return;
      }

      window.open(fileUrl, "_blank");
    } catch (error) {
      const msg = error?.response?.data?.message || "Download failed";
      toast.error(msg);
      console.log("Download Error", error);
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    fetchReportList();

    return () => {
      setSelectedFormat("");
      setMobileNumber("");
      setSendTo("");
    };
  }, []);

  // useEffect(() => {
  //   return () => {
  //     setSelectedFormat("");
  //     setMobileNumber("");
  //     setSendTo(reportOptions[0]);
  //   };
  // }, []);

  const handleFormatChange = (event) => {
    setSelectedFormat(event.target.value);
  };

  switch (modalType) {
    case "WhatsApp":
      modal = <WhatsAppModalBody mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} sendTo={sendTo} setSendTo={setSendTo} reportOptions={reportOptions} onClick={onClick} type={type} data={data} />;
      break;

    case "Message":
      modal = (
        <EmailModalBody
          email={email}
          setEmail={setEmail}
          selectedFormat={selectedFormat}
          setSelectedFormat={setSelectedFormat}
          handleFormatChange={handleFormatChange}
          sendTo={sendTo}
          setSendTo={setSendTo}
          reportOptions={reportOptions}
          onClick={onClick}
          type={type}
          data={data}
        />
      );
      break;

    case "Download":
      modal = (
        <DownloadModalBody
          selectedFormat={selectedFormat}
          setSelectedFormat={setSelectedFormat}
          handleFormatChange={handleFormatChange}
          sendTo={sendTo}
          setSendTo={setSendTo}
          reportOptions={reportOptions}
          onClick={handleDownload}
          type={type}
          data={data}
          isLoading={isDownloading}
        />
      );
      break;

    case "WhatsAppBA":
      modal = <WhatsAppBAModalBody mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} onClick={onClick} type={type} />;
      break;

    case "EmailBA":
      modal = <EmailModalBABody email={email} setEmail={setEmail} onClick={onClick} type={type} />;
      break;

    default:
      modal = <Typography></Typography>;
      break;
  }

  return (
    <Modal style={{ width: "fit-content", Padding: "24px 20px", border: "2px solid blue" }} open={open} handleClose={handleClose}>
      <Box>{modal}</Box>
    </Modal>
  );
};

export default ClientDynamicModal;
